export const environment = {
    production: false,
    apiUrl: 'https://app.dev.beastborne.com/api/',
    // apiUrl: 'http://localhost:5000/api/',
    blockchain: 'Sepolia Testnet',
    nftContractAddress: '0x7dB16683ca3E629585764b1516787964E4Dae8d5',
    nftContractNetwork: 'Sepolia Testnet',
    nftBreedingContractAddress: '0x87820869afec4787E2f08340009D56cBB889b138',
    nftBreedingContractNetwork: 'Sepolia Testnet',
    coinContractAddress: '0xaf3D83903BeA6fDfeEa57d686F96deC845639028',
    coinContractNetwork: 'Sepolia Testnet',
    adminAddress: '0x604c3cc8fa53627E6c89a38CCdCBa602122c60D6'
};
